export enum PaymentEntityType {
    AMENITY = 'amenity',
    PROPERTY = 'property'
}
